// @flow

import { View } from '@insolus/backbone';

// - Stylesheet
require('./inscription-step-auth.less');

class InscriptionStepAuth extends View {
    get isPrerendered(): boolean { return true; }

    initialize() {
        this.render();
    }
}

export default InscriptionStepAuth;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/inscription-step-auth/inscription-step-auth.js